// extracted by mini-css-extract-plugin
export default {"buttonGroup":"buttonGroup---hlikH","fullWidth":"fullWidth---JzDrD"};